import classNames from 'classnames';
import * as React from 'react';

export const Container = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <div
    className={classNames({
      'xxs:max-w-695 xs:max-w-695 sm:max-w-810 md:max-w-810 lg:max-w-900  lg1:max-w-1056 xl:max-w-1056 mx-auto xxxs:max-w-810 small:px-16':
        true,
      // 'xxs:max-w-640 xs:max-w-640 sm:max-w-752 md:max-w-848 lg:max-w-960 mx-auto xxxs:max-w-768':

      [className || '']: !!className,
    })}
  >
    {children}
  </div>
);

export const ContainerFixedMargin = ({
  children,
  className,
  id,
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => (
  <div
    className={classNames({
      'mobile:mx-24 tablet:mx-42 laptop:mx-64 desktop:mx-90 bigScreen:mx-auto bigScreen:max-w-1140':
        true,
      [className || '']: !!className,
    })}
  >
    {children}
  </div>
);

export const ContainerTwo = ({
  children,
  className,
  id,
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => (
  <div
    className={classNames({
      'mobile:mx-24 tablet:mx-42 laptop:mx-64 desktop:ml-90 desktop:mr-4  bigScreen:ml-256 bigScreen:max-w-1140  bigScreen:mr-4 bigScreenTwo:max-w-1240 bigScreenTwo:mx-auto':
        true,
      [className || '']: !!className,
    })}
  >
    {children}
  </div>
);

// mobile: '320px'-'480px',
// tablet: '481px',-'768px',
// laptop: '769px'-'1024px',
// desktop: '1025px'-'1200px'
